import { Grid, Button, Typography, TextField } from "@mui/material";

const Choices = ({
  questionData,
  handleChoiceChange,
  removeChoice,
  addChoice,
  baseQuestion
}) => {
  if (
    questionData.questionType === "choice" ||
    questionData.questionType === "multipleChoice"
  ) {
    return (
      <Grid item xs={12}>
        <Typography variant="subtitle1" style={{ marginBottom: 16 }}>
          Choices 
        </Typography>
        {questionData.choices.map((choice, index) => (
          <Grid container spacing={2} key={index} sx={{ marginBottom: 3 }}>
            <Grid item xs={5}>
              <TextField
                fullWidth
                label={`Choice ${index + 1}`}
                value={choice.label}
                onChange={(e) => handleChoiceChange(index, e.target.value)}
                disabled={baseQuestion}
              />
            </Grid>
            <Grid item xs={2}>
              <Button
                variant="outlined"
                color="error"
                onClick={() => removeChoice(index)}
                disabled={baseQuestion}
              >
                Remove
              </Button>
            </Grid>
          </Grid>
        ))}
        <Button variant="contained" onClick={addChoice} disabled={baseQuestion}>
          Add Choice
        </Button>
      </Grid>
    );
  }

  return <></>;
};

export default Choices;
